import type { TableCellProps } from '@mui/material/TableCell';

export enum headerColumnTypes {
    DATE_TIME = 'DATE_TIME',
    SORTABLE = 'SORTABLE',
    SORTABLE_DATE_TIME = 'SORTABLE_DATE_TIME',
}

export enum sortDirections {
    ASC = 'asc',
    DESC = 'desc',
}

export enum defaultFilterTypes {
    DEFAULT_STRING_FILTER_TYPE = 'DEFAULT_STRING_FILTER_TYPE',
    DEFAULT_ID_FILTER_TYPE = 'DEFAULT_ID_FILTER_TYPE',
    DEFAULT_BOOLEAN_FILTER_TYPE = 'DEFAULT_BOOLEAN_FILTER_TYPE',
    DEFAULT_STRING_ID_FILTER_TYPE = 'DEFAULT_STRING_ID_FILTER_TYPE',
    DEFAULT_DATE_FROM_FILTER_TYPE = 'DEFAULT_DATE_FROM_FILTER_TYPE',
    DEFAULT_DATE_TO_FILTER_TYPE = 'DEFAULT_DATE_TO_FILTER_TYPE',
    DEFAULT_INTEGER_ID_FILTER_TYPE = 'DEFAULT_INTEGER_ID_FILTER_TYPE',
    DEFAULT_DATE_TIME_FROM_FILTER_TYPE = 'DEFAULT_DATE_TIME_FROM_FILTER_TYPE',
    DEFAULT_DATE_TIME_TO_FILTER_TYPE = 'DEFAULT_DATE_TIME_TO_FILTER_TYPE',
    DEFAULT_INTEGER_SUB_ENTITY_ID_FILTER_TYPE = 'DEFAULT_INTEGER_SUB_ENTITY_ID_FILTER_TYPE',
}

export interface IFilterContent {
    filterType: defaultFilterTypes;
    filterKey: string;
    value: string | number | Date | null | IFilterOptionState;
    timeZone?: string;
}

export interface IFilterOptionState {
    Id: string;
    label: string;
    color?: string;
}

export interface ITableHeaderSortableProps {
    sortKey: string;
    defaultSortDir?: sortDirections;
}

export type ITableHeaderColumn = Omit<TableCellProps, 'children'> & {
    id: string;
    labelText: string;
    titleText?: string;
    columnType?: headerColumnTypes;
    sortableProps?: ITableHeaderSortableProps;
};

export enum ListViewType {
    TABLE = 'TABLE',
    CALENDAR = 'CALENDAR',
}
